import Api from '@/services/Api';

let refreshToken = localStorage.getItem('refresh_token');
let dati = [{ refreshToken: refreshToken}];
let datiJSON = JSON.stringify(dati[0]);

export default {
  searchInformation(azienda, cf, p_iva) {
    return Api().get('azienda?filter=true&name=' + azienda + '&CF=' + cf + '&piva=' + p_iva +'&relazioni=true');
  },
  
  getSedi() {
    return Api().get('/users/sede');
  },

  refreshToken() {
    return Api().post('/token', datiJSON);
  },

  logout() {
    return Api().delete('/logout');
  },

  logoutFunction: async function () {
    console.log(`logoutFunction`);
    await Api().delete('/logout')
    .then(response => { this.results = response.data})
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.setItem('isLogged', false);
    localStorage.removeItem('user_nome');
    localStorage.removeItem('user_cognome');
    localStorage.removeItem('user_tipologia');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_livello');
    localStorage.removeItem('user_id');
    window.location.href = '/#/login';
  },

  refreshTokenFunction: async function(){
    let token_response;
    let errore = 0;
    await Api().post('/token', datiJSON)
    .then(response => { token_response = response.data})
    .catch(function (error) {
        // handle error
        if(error.response.status == 403){
            errore = error.response.status;
        } else if (error.response.status == 401) {
            errore = error.response.status;
        }
    });
    console.log(`errore fuori da catch refreshToken = ${errore}`);
    if(errore == 403 || errore == 401){
        console.log(`errore = ${errore} -> fai logout`);
        await this.logoutFunction();
        return false;
    } 
    localStorage.setItem('access_token', token_response.accessToken);
    return true;
  },
}